/**
 * Accounts S4 (0140): the region and sector code lists. The ONE list the api
 * and the migration read is pkg/contracts/codes.json; ./codes.json is its
 * BYTE-IDENTICAL copy, because the frontend Docker build's context is webapp/
 * only and an import across that boundary does not resolve there (CI #1716,
 * TS2307). pkg/contracts' TestWebappCodesJSONIsByteIdentical fails on any
 * difference — edit pkg/contracts/codes.json and copy it here. Region is an
 * ONS ITL1 (January 2025) code or OUTSIDE_UK; sector is a SIC 2007 section,
 * stored scheme-qualified ("SIC2007:J"). '' means not set.
 */
import codes from './codes.json'

export interface AccountCode { code: string; label: string }

export const REGIONS: readonly AccountCode[] = codes.region.codes
export const SECTORS: readonly AccountCode[] = codes.sector.codes

const regionLabels = new Map(REGIONS.map(c => [c.code, c.label]))
const sectorLabels = new Map(SECTORS.map(c => [c.code, c.label]))

/** The region's label; '' when not set. An unknown code (an api newer than
 *  this bundle) shows as itself rather than vanishing. */
export function regionLabel(code: string | undefined): string {
  if (!code) return ''
  return regionLabels.get(code) ?? code
}

/** The sector's label, as above. */
export function sectorLabel(code: string | undefined): string {
  if (!code) return ''
  return sectorLabels.get(code) ?? code
}
